export const DEFAULT_TIMEZONE = 'Europe/Moscow';

/** Популярные IANA-таймзоны (РФ, СНГ и UTC). */
const TIMEZONE_OPTIONS = [
  'Europe/Kaliningrad',
  'Europe/Moscow',
  'Europe/Samara',
  'Asia/Yekaterinburg',
  'Asia/Omsk',
  'Asia/Krasnoyarsk',
  'Asia/Irkutsk',
  'Asia/Yakutsk',
  'Asia/Vladivostok',
  'Asia/Magadan',
  'Asia/Kamchatka',
  'Europe/Minsk',
  'Asia/Almaty',
  'Asia/Tbilisi',
  'Asia/Baku',
  'UTC',
] as const;

export function timezoneI18nKey(timezone: string): string {
  return timezone.replace(/\//g, '_');
}

function isValidTimezone(timezone: string): boolean {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: timezone });
    return true;
  } catch {
    return false;
  }
}

export function normalizeTimezone(timezone: string | undefined): string {
  if (!timezone?.trim()) {
    return DEFAULT_TIMEZONE;
  }
  const trimmed = timezone.trim();
  if (!isValidTimezone(trimmed)) {
    return DEFAULT_TIMEZONE;
  }
  return trimmed;
}

export function buildTimezoneOptions(currentValue: string): string[] {
  const normalized = normalizeTimezone(currentValue);
  if ((TIMEZONE_OPTIONS as readonly string[]).includes(normalized)) {
    return [...TIMEZONE_OPTIONS];
  }
  return [normalized, ...TIMEZONE_OPTIONS];
}

export function formatTimezoneOffset(timezone: string, locale: 'ru' | 'en'): string {
  try {
    const parts = new Intl.DateTimeFormat(locale === 'en' ? 'en-US' : 'ru-RU', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    }).formatToParts(new Date());
    return parts.find((part) => part.type === 'timeZoneName')?.value ?? '';
  } catch {
    return '';
  }
}
